import React from "react";
import {
  Title,
  TabbedShowLayout,
  Tab,
  FunctionField,
} from "react-admin";
import { Card, CardContent } from "@material-ui/core";
import GtinListTab from "./components/GtinListTab";
import CalculationTab from "./components/CalculationTab";

const EcobalyseShow = () => {
  return (
    <>
      <Title title="Ecobalyse" />
      <Card style={{ marginTop: '1em' }}>
        <CardContent>
          <TabbedShowLayout
            record={{}} // Record vacío para evitar errores
            resource="ecobalyse"
            basePath="/ecobalyse"
            version={1}
          >
            <Tab label="GTIN List">
              <FunctionField
                label=""
                addLabel={false}
                render={() => <GtinListTab />}
              />
            </Tab>

            <Tab label="Calculation">
              <FunctionField
                label=""
                addLabel={false}
                render={() => <CalculationTab />}
              />
            </Tab>
          </TabbedShowLayout>
        </CardContent>
      </Card>
    </>
  );
};

export default EcobalyseShow;
